export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-8">关于我们</h2>
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-2xl bg-primary-100">
            <i className="ri-movie-2-line text-3xl text-primary-600"></i>
          </div>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            91影视看片app是专为影视爱好者打造的高清<strong className="text-foreground-900">免费影视在线观看</strong>平台。我们坚持「打开即看」的理念，聚合全网优质高清片源，涵盖热播电视剧、院线电影、人气综艺与经典动漫。平台采用智能线路调度技术，确保<strong className="text-foreground-900">在线看片不缓冲</strong>，无论何时何地，你都能享受流畅的高清观影体验。无需注册、无需付费，打造你的专属<strong className="text-foreground-900">免费追剧平台</strong>。
          </p>
        </div>
      </div>
    </section>
  );
}